/**
 * @generated SignedSource<<d52bb1730320ef2e5cc3d99053cc0162>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ECommerce = "AMAZON" | "API" | "BIG_COMMERCE" | "CODE_CANYON" | "C_CLOUD" | "ETSY" | "MAGENTO" | "MAGENTO1" | "NET_SUITE" | "NONE" | "OPEN_CART" | "PRESTA_SHOP" | "SHOPIFY" | "SHOPWARE" | "WIX" | "WOO_COMMERCE";
export type PricingVersion = "VERSION_1" | "VERSION_2";
export type ProductProvider = "CASA_DE_LAS_CARCASAS" | "CUSTOM_CAT" | "FAVORITE_GIFT" | "HP" | "INVITION" | "PRINTFUL" | "PRINTFUL_DIRECT" | "UNDEFINED" | "VERSORI" | "ZAKEKE";
export type ZakekeEnvironment = "COMPOSER" | "CUSTOMIZER" | "UNKNOWN" | "VIEWER";
export type testPageQuery$variables = {
  productId: string;
};
export type testPageQuery$data = {
  readonly model: {
    readonly additionalCodes: ReadonlyArray<{
      readonly code: string;
      readonly merchantProductName: string;
      readonly salesChannel: {
        readonly ecommerceSettings: {
          readonly definitiveUrl: string | null;
          readonly ecommerceName: ECommerce;
          readonly remoteUrl: string | null;
        } | null;
        readonly id: string;
      };
      readonly salesChannelID: string;
    }>;
    readonly canAddAdditionalCode: boolean;
    readonly code: string;
    readonly colors: ReadonlyArray<{
      readonly code: string | null;
      readonly colorCode: string | null;
      readonly colorID: number;
      readonly name: string;
    }>;
    readonly id: string;
    readonly iframeUrl: {
      readonly copyUrl: string;
      readonly testUrl: string;
    };
    readonly modelColorMappings: ReadonlyArray<{
      readonly colorID: number;
      readonly merchantCode: string;
      readonly salesChannelID: string;
    }>;
    readonly name: string;
    readonly printTypes: ReadonlyArray<{
      readonly printTypeID: number;
    }>;
    readonly provider: ProductProvider;
    readonly salesChannel: {
      readonly ecommerceSettings: {
        readonly definitiveUrl: string | null;
        readonly ecommerceName: ECommerce;
        readonly hasProductsApi: boolean;
        readonly isMarketplace: boolean;
        readonly productsApi: string | null;
        readonly remoteUrl: string | null;
      } | null;
      readonly id: string;
    };
    readonly statusID: number;
    readonly zakekeEnvironment: ZakekeEnvironment;
  } | null;
  readonly salesChannels: ReadonlyArray<{
    readonly detail: {
      readonly id: string;
      readonly properties: {
        readonly name: string | null;
      } | null;
    } | null;
    readonly ecommerceSettings: {
      readonly definitiveUrl: string | null;
      readonly ecommerceID: number;
      readonly ecommerceName: ECommerce;
      readonly hasProductsApi: boolean;
      readonly isMarketplace: boolean;
      readonly remoteUrl: string | null;
    } | null;
    readonly id: string;
  }>;
  readonly sellerUserInterfaces: {
    readonly nodes: ReadonlyArray<{
      readonly isDefault: boolean;
      readonly userInterfaceId: number | null;
    } | null> | null;
  } | null;
  readonly shopifyAuthEcommerceSettings: {
    readonly isTestStore: boolean;
  } | null;
  readonly subscription: {
    readonly inTrial: boolean;
    readonly isOverMaxNumTestOrders: boolean;
    readonly maxNumTestOrders: number | null;
    readonly maxProducts: {
      readonly maxProducts: number | null;
      readonly numProducts: number | null;
      readonly numPublishedProducts: number | null;
      readonly pricingVersion: PricingVersion;
    };
  } | null;
  readonly testOrderNumberInBillingDate: number;
};
export type testPageQuery = {
  response: testPageQuery$data;
  variables: testPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "productId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "productId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "provider",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "statusID",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "ModelPrintType",
  "kind": "LinkedField",
  "name": "printTypes",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "printTypeID",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "colorID",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "Color",
  "kind": "LinkedField",
  "name": "colors",
  "plural": true,
  "selections": [
    (v8/*:: as any*/),
    (v3/*:: as any*/),
    (v4/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "colorCode",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "MarketplaceIframe",
  "kind": "LinkedField",
  "name": "iframeUrl",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "testUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "copyUrl",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ecommerceName",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "remoteUrl",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "productsApi",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasProductsApi",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isMarketplace",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "definitiveUrl",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "zakekeEnvironment",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canAddAdditionalCode",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "salesChannelID",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "merchantProductName",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "ModelColorMapping",
  "kind": "LinkedField",
  "name": "modelColorMappings",
  "plural": true,
  "selections": [
    (v8/*:: as any*/),
    (v19/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "merchantCode",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "testOrderNumberInBillingDate",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "MaxProducts",
  "kind": "LinkedField",
  "name": "maxProducts",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pricingVersion",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "numPublishedProducts",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "maxProducts",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "numProducts",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "maxNumTestOrders",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isOverMaxNumTestOrders",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "inTrial",
  "storageKey": null
},
v27 = [
  {
    "kind": "Literal",
    "name": "status",
    "value": "ACTIVE"
  }
],
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ecommerceID",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "concreteType": "SalesChannelDetail",
  "kind": "LinkedField",
  "name": "detail",
  "plural": false,
  "selections": [
    (v2/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "SalesChannelDetailProperties",
      "kind": "LinkedField",
      "name": "properties",
      "plural": false,
      "selections": [
        (v3/*:: as any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "concreteType": "ShopifyAuthEcommerceSettings",
  "kind": "LinkedField",
  "name": "shopifyAuthEcommerceSettings",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isTestStore",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v31 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isDefault",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userInterfaceId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "testPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Model",
        "kind": "LinkedField",
        "name": "model",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v4/*:: as any*/),
          (v5/*:: as any*/),
          (v6/*:: as any*/),
          (v7/*:: as any*/),
          (v9/*:: as any*/),
          (v10/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SalesChannel",
            "kind": "LinkedField",
            "name": "salesChannel",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "EcommerceSettings",
                "kind": "LinkedField",
                "name": "ecommerceSettings",
                "plural": false,
                "selections": [
                  (v11/*:: as any*/),
                  (v12/*:: as any*/),
                  (v13/*:: as any*/),
                  (v14/*:: as any*/),
                  (v15/*:: as any*/),
                  (v16/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v17/*:: as any*/),
          (v18/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ProductCode",
            "kind": "LinkedField",
            "name": "additionalCodes",
            "plural": true,
            "selections": [
              (v4/*:: as any*/),
              (v19/*:: as any*/),
              (v20/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SalesChannel",
                "kind": "LinkedField",
                "name": "salesChannel",
                "plural": false,
                "selections": [
                  (v2/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EcommerceSettings",
                    "kind": "LinkedField",
                    "name": "ecommerceSettings",
                    "plural": false,
                    "selections": [
                      (v11/*:: as any*/),
                      (v12/*:: as any*/),
                      (v16/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v21/*:: as any*/)
        ],
        "storageKey": null
      },
      (v22/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "ZakekeSubscription",
        "kind": "LinkedField",
        "name": "subscription",
        "plural": false,
        "selections": [
          (v23/*:: as any*/),
          (v24/*:: as any*/),
          (v25/*:: as any*/),
          (v26/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v27/*:: as any*/),
        "concreteType": "SalesChannel",
        "kind": "LinkedField",
        "name": "salesChannels",
        "plural": true,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "EcommerceSettings",
            "kind": "LinkedField",
            "name": "ecommerceSettings",
            "plural": false,
            "selections": [
              (v28/*:: as any*/),
              (v11/*:: as any*/),
              (v15/*:: as any*/),
              (v14/*:: as any*/),
              (v12/*:: as any*/),
              (v16/*:: as any*/)
            ],
            "storageKey": null
          },
          (v29/*:: as any*/)
        ],
        "storageKey": "salesChannels(status:\"ACTIVE\")"
      },
      (v30/*:: as any*/),
      {
        "alias": null,
        "args": (v31/*:: as any*/),
        "concreteType": "SellerUserInterfacesConnection",
        "kind": "LinkedField",
        "name": "sellerUserInterfaces",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SellerUserInterface",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v32/*:: as any*/),
              (v33/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": "sellerUserInterfaces(first:1)"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "testPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Model",
        "kind": "LinkedField",
        "name": "model",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v4/*:: as any*/),
          (v5/*:: as any*/),
          (v6/*:: as any*/),
          (v7/*:: as any*/),
          (v9/*:: as any*/),
          (v10/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SalesChannel",
            "kind": "LinkedField",
            "name": "salesChannel",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "EcommerceSettings",
                "kind": "LinkedField",
                "name": "ecommerceSettings",
                "plural": false,
                "selections": [
                  (v11/*:: as any*/),
                  (v12/*:: as any*/),
                  (v13/*:: as any*/),
                  (v14/*:: as any*/),
                  (v15/*:: as any*/),
                  (v16/*:: as any*/),
                  (v2/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v17/*:: as any*/),
          (v18/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ProductCode",
            "kind": "LinkedField",
            "name": "additionalCodes",
            "plural": true,
            "selections": [
              (v4/*:: as any*/),
              (v19/*:: as any*/),
              (v20/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SalesChannel",
                "kind": "LinkedField",
                "name": "salesChannel",
                "plural": false,
                "selections": [
                  (v2/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EcommerceSettings",
                    "kind": "LinkedField",
                    "name": "ecommerceSettings",
                    "plural": false,
                    "selections": [
                      (v11/*:: as any*/),
                      (v12/*:: as any*/),
                      (v16/*:: as any*/),
                      (v2/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v21/*:: as any*/)
        ],
        "storageKey": null
      },
      (v22/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "ZakekeSubscription",
        "kind": "LinkedField",
        "name": "subscription",
        "plural": false,
        "selections": [
          (v23/*:: as any*/),
          (v24/*:: as any*/),
          (v25/*:: as any*/),
          (v26/*:: as any*/),
          (v2/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v27/*:: as any*/),
        "concreteType": "SalesChannel",
        "kind": "LinkedField",
        "name": "salesChannels",
        "plural": true,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "EcommerceSettings",
            "kind": "LinkedField",
            "name": "ecommerceSettings",
            "plural": false,
            "selections": [
              (v28/*:: as any*/),
              (v11/*:: as any*/),
              (v15/*:: as any*/),
              (v14/*:: as any*/),
              (v12/*:: as any*/),
              (v16/*:: as any*/),
              (v2/*:: as any*/)
            ],
            "storageKey": null
          },
          (v29/*:: as any*/)
        ],
        "storageKey": "salesChannels(status:\"ACTIVE\")"
      },
      (v30/*:: as any*/),
      {
        "alias": null,
        "args": (v31/*:: as any*/),
        "concreteType": "SellerUserInterfacesConnection",
        "kind": "LinkedField",
        "name": "sellerUserInterfaces",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SellerUserInterface",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v32/*:: as any*/),
              (v33/*:: as any*/),
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": "sellerUserInterfaces(first:1)"
      }
    ]
  },
  "params": {
    "cacheID": "080439be7051171529a6a73193430bbd",
    "id": null,
    "metadata": {},
    "name": "testPageQuery",
    "operationKind": "query",
    "text": "query testPageQuery(\n  $productId: ID!\n) {\n  model(id: $productId) {\n    id\n    name\n    code\n    provider\n    statusID\n    printTypes {\n      printTypeID\n    }\n    colors {\n      colorID\n      name\n      code\n      colorCode\n    }\n    iframeUrl {\n      testUrl\n      copyUrl\n    }\n    salesChannel {\n      id\n      ecommerceSettings {\n        ecommerceName\n        remoteUrl\n        productsApi\n        hasProductsApi\n        isMarketplace\n        definitiveUrl\n        id\n      }\n    }\n    zakekeEnvironment\n    canAddAdditionalCode\n    additionalCodes {\n      code\n      salesChannelID\n      merchantProductName\n      salesChannel {\n        id\n        ecommerceSettings {\n          ecommerceName\n          remoteUrl\n          definitiveUrl\n          id\n        }\n      }\n    }\n    modelColorMappings {\n      colorID\n      salesChannelID\n      merchantCode\n    }\n  }\n  testOrderNumberInBillingDate\n  subscription {\n    maxProducts {\n      pricingVersion\n      numPublishedProducts\n      maxProducts\n      numProducts\n    }\n    maxNumTestOrders\n    isOverMaxNumTestOrders\n    inTrial\n    id\n  }\n  salesChannels(status: ACTIVE) {\n    id\n    ecommerceSettings {\n      ecommerceID\n      ecommerceName\n      isMarketplace\n      hasProductsApi\n      remoteUrl\n      definitiveUrl\n      id\n    }\n    detail {\n      id\n      properties {\n        name\n      }\n    }\n  }\n  shopifyAuthEcommerceSettings {\n    isTestStore\n  }\n  sellerUserInterfaces(first: 1) {\n    nodes {\n      isDefault\n      userInterfaceId\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "fc346b524b7903c969ff951d91cf8eb6";

export default node;
